import { useState } from "react";

import { useMyVenueShifts } from "@/features/shifts/model/useShifts";
import { ShiftCard } from "@/features/shifts/ui/ShiftCard";
import type { ShiftStatus } from "@/features/shifts/types";
import { cn } from "@/shared/lib/cn";

const STATUS_TABS: Array<{ label: string; value: ShiftStatus | undefined }> = [
  { label: "All", value: undefined },
  { label: "Open", value: "OPEN" },
  { label: "Filled", value: "FILLED" },
  { label: "Completed", value: "COMPLETED" },
  { label: "Cancelled", value: "CANCELLED" },
];

export function ShiftManagement() {
  const [status, setStatus] = useState<ShiftStatus | undefined>(undefined);
  const { data, isLoading, error } = useMyVenueShifts(status);

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-2">
        {STATUS_TABS.map((tab) => (
          <button
            key={tab.label}
            onClick={() => setStatus(tab.value)}
            className={cn(
              "whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
              status === tab.value
                ? "bg-primary text-primary-foreground"
                : "border border-input text-muted-foreground hover:bg-surface-sunken",
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {isLoading && <div className="text-sm text-muted-foreground">Loading...</div>}
      {error && <div className="text-sm text-destructive">Could not load shifts.</div>}

      {data && data.shifts.length === 0 && (
        <div className="rounded-lg border bg-card p-8 text-center text-sm text-muted-foreground">
          No shifts in this view.
        </div>
      )}

      {data && data.shifts.length > 0 && (
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
          {data.shifts.map((shift) => (
            <ShiftCard
              key={shift.id}
              shift={shift}
              to={`/venue/shifts/${shift.id}`}
              showStatus
              hideVenueSummary
            />
          ))}
        </div>
      )}
    </div>
  );
}
